import { IOptionValue } from "shared/interfaces/Catalog.interface";
import { IOrderItem } from "shared/interfaces/Order.interface";

export default (value: IOptionValue, currentDish: IOrderItem): boolean => {
  const index = currentDish.modifiers.findIndex(
    (modifier) => modifier.id === value.id
  );
  return index !== -1;
};
